import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { provideAuthenticationApiConfiguration } from './api/proxy/authentication/authentication-api-configuration';
import { provideEnvironmentApiConfiguration } from './api/proxy/environment/environment-api-configuration';
import { providePracticeApiConfiguration } from './api/proxy/practice/practice-api-configuration';
import { GlobalHttpInterceptorService } from './services/auth-service/global-http-intercepter-service';
import { LoaderModule } from './components/loader/loader.module';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    TranslateModule.forRoot({
      fallbackLang: environment.defaultLanguage
    }),
    AppRoutingModule,
    LoaderModule,
  ],
  providers: [
    provideEnvironmentApiConfiguration(environment.appEnvironmentBaseUrl),
    providePracticeApiConfiguration(''),
    provideAuthenticationApiConfiguration(''),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptorService, multi: true },
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
      enforceLoading: false,
      useHttpBackend: false
    }),
    provideHttpClient(withInterceptorsFromDi())],
  bootstrap: [AppComponent],
})
export class AppModule { }